import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { ComissaoEticaService } from '@/core/api/sicom-api/servicos/pessoa-juridica/comissao-etica/comissao-etica.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { ComissaoEticaRequest, ComissaoEticaResponse } from '@/core/api/sicom-api/servicos/pessoa-juridica/comissao-etica/comissao-etica.model';

@Injectable({ providedIn: 'root' })
export class ComissaoEticaServicosService {
    constructor(
        private api: ComissaoEticaService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: ComissaoEticaRequest, context?: HttpContext): Observable<ComissaoEticaResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
